import React from 'react'
import { Form,  ListGroup, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../constants/globalConstants'
import { errorMessage } from '../constants/errorMessage'
// import moment from 'moment'
// import { getCardIcon } from '../utils/helper'
require('./CommonListModal.scss')

function RateBandDropDownList(props) {
    const { isRateBandModal, setIsRateBandModal, listData, register, handleCurrentSelection } = props
    return (
        <div>
            <Modal show={isRateBandModal} onHide={() => setIsRateBandModal()} centered className='commonModalDialogbox' animation={false}>
                <Modal.Body className='scrollable-Modal'>
                    <ListGroup as="ol" variant="flush">
                        {listData?.length > 0 ? listData?.map((item, index) =>
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" key={index} onClick={() => handleCurrentSelection(item)} {...register('rate_band_id')}>
                                <div className="ms-2 me-auto"><div className="fw-semibold text-primary" style={{ marginTop: '0.7rem' }}>{item?.rate_band_description}</div></div>
                            </ListGroup.Item>
                        ) : <Form.Text className="text-danger">{errorMessage?.noDataAvailable}</Form.Text>}
                    </ListGroup>
                </Modal.Body>
                <span className='text-danger text-center mb-2' onClick={() => setIsRateBandModal()}>Close</span>
            </Modal>
        </div>
    )
}

RateBandDropDownList.propTypes = {
    dispatch: PropTypes.func,
    isRateBandModal: PropTypes.bool,
    setIsRateBandModal: PropTypes.func,
    listData: PropTypes.array,
    register: PropTypes.func,
    handleCurrentSelection: PropTypes.func,
    isThisVehicleModal: PropTypes.bool
}

RateBandDropDownList.defaulProps = {
    dispatch: noop,
    isRateBandModal: false,
    setIsRateBandModal: noop,
    listData: EMPTY_ARRAY,
    register: noop,
    handleCurrentSelection: noop,
    isThisVehicleModal: false
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(RateBandDropDownList)